import accountService from "../services/account";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        document: {
            loa: null,
            government_id: null,
            authorization_letter: null
        }
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setDocument(state, value) {
            state.document.government_id = value.govtID;
            state.document.loa = value.loa;
            state.document.authorization_letter = value.authorization;
        },

        setUpdatedDocument(state, response) {
            state.document.government_id = response.government_id;
            state.document.loa = response.loa;
            state.document.authorization_letter = response.authorization_letter;
        }
    },
    getters: {
        getUpdatedDocuments(state) {
            return state.document;
        }
    },
    actions: {
        getDocuments: async ({ commit }) => {
            commit("loading");
            try {
                let response = await accountService.getDocuments();
                commit("setUpdatedDocument", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        updateDocuments: async ({ commit, state }) => {
            commit("loading");
            try {
                let response = await accountService.updateDocument(
                    state.document
                );
                notification.success(response.message);
                commit("setUpdatedDocument", response.merchant);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        }
    }
};
